import type { ModalOpenSource } from "@/utils/tracking";

export interface WidgetEvent {
  type: "open";
  source: ModalOpenSource;
  /** Chip key to pre-filter the sheet with (e.g. "sleep"). */
  topic?: string;
}

type Listener = (event: WidgetEvent) => void;

const listeners = new Set<Listener>();

export const widgetEventBus = {
  subscribe(cb: Listener): () => void {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
  emit(event: WidgetEvent): void {
    listeners.forEach((cb) => cb(event));
  },
};
